var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApplicantCabinetIconsIcon',_vm._b({staticClass:"vsm--icon",attrs:{"icon-name":typeof _vm.icon === 'string' || (_vm.icon instanceof String) ? _vm.icon : _vm.icon.name}},'ApplicantCabinetIconsIcon',_vm.icon.attributes,false))}
var staticRenderFns = []

export { render, staticRenderFns }